<template>
    <el-scrollbar class="dsVideoRank">
        <div class="dsVideoRank-header">
            <div class="commodityClassify">
                <el-table
                    v-show="isProduct == 1"
                    style="width: 100%;"
                    class="tableList"
                    :data="productList"
                    :header-cell-style="{ fontWeight: 'normal', color: '#333333', fontSize: '14px', fontWeight: '400' }"
                    :cell-style="{ fontSize: '12px', color: '#333' }"
                >
                    <el-table-column class="tableList-item" label="排行" align="center" width="82">
                        <template slot-scope="scope">
                            <span class="ranking-num">{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="video_cover_url" label="视频" align="center" width="200">
                        <template slot-scope="scope">
                            <img class="videoImg" :src="scope.row.video_cover_url" alt="" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="desc" label="" align="left" width="">
                        <template slot-scope="scope">
                            <p class="describe-title">{{ scope.row.desc }}</p>
                            <p class="describe-content">
                                关联商品：<span>{{ scope.row.promotions }}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="digg_count" label="达人" align="center" width="150">
                        <template slot-scope="scope">
                            <span class="text-overflow">{{ scope.row.nickname }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="digg_count" label="点赞数" align="center" width="100"></el-table-column>
                    <el-table-column prop="share_count" label="转发数" align="center" width="100"></el-table-column>
                    <el-table-column prop="comment_count" label="评论数" align="center" width="100"></el-table-column>
                    <el-table-column prop="volume" label="预估销量" align="center" width="140">
                        <template slot-scope="scope">
                            <span>{{ scope.row.volume }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="预估销售额" align="center" width="140">
                        <template slot-scope="scope">
                            <span>{{ scope.row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="190">
                        <template slot-scope="scope">
                            <span style="cursor: pointer" class="data-icon" @click="toVideoDetail(scope.row)">
                                <i class="iconfont">&#xe601;</i>
                            </span>
                            <a target="_blank" :href="scope.row.video_share_url">
                                <span class="play-icon"><i class="iconfont" style="padding-left: 3px;">&#xe628;</i></span>
                            </a>
                            <span @click="toAnalysis(scope.row, 'goodsAnalyzes')" style="cursor: pointer" class="chart-icon">
                                <i class="iconfont">&#xe60d;</i>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                v-if="productList.length > 0"
                style="margin-bottom: 10px"
                :background="true"
                class="pages-center"
                :current-page="adminPages.currentPageNum"
                :page-size="adminPages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="adminPages.total"
                @current-change="adminCurrentChange"
            ></el-pagination>
        </div>
    </el-scrollbar>
</template>

<script>
// import { endDate, defaultDay } from "@/utils/common";

export default {
    name: "DsVideoRanking",
    data() {
        return {
            isNext: true,
            isSelectId: "",
            pickerDisabled: {
                // 禁选当天之后的日期
                disabledDate: (time) => {
                    return time.getTime() > Date.parse("2024-04-14 00:00:00");
                },
            },
            isListDate: "",
            selectDateDay: "", //日
            selectDateWeek: "", //周
            selectDateMonth: "", //月
            radio: "日榜",
            dateValue: "",
            dateList: [
                {
                    value: "选项1",
                    label: "10月14日",
                },
                {
                    value: "选项2",
                    label: "10月15日",
                },
            ],
            searchContent: "",
            searchContentTwo: "",
            commodityClassify: [
                "服饰鞋包",
                "护肤美容",
                "日用百货",
                "家居家装",
                "数码家电",
                "运动户外",
                "汽车",
                "餐饮食品",
                "母婴儿童",
                "钟表首饰",
                "文化娱乐",
                "鲜花园艺",
                "宠物服务",
                "医药保健",
            ],
            productList: [], //视频商品
            productListTwo: [],
            isProduct: 1,
            //分页
            adminPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            lweekVal: "",
            data_type: Number(this.$route.query.data_type),
        };
    },
    created() {
        this.getElectricityVideo();
    },
    methods: {
        queryTwo(searchContentTwo) {
            return this.productListTwo.filter((item) => {
                if (item.desc.includes(searchContentTwo)) {
                    return item;
                }
            });
        },
        //时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
        dateFormat: function(time) {
            var date = new Date(time * 1000);
            var year = date.getFullYear();
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        },
        // 时间戳为13位
        dateFormatTwo: function(time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        },
        selectElectricityVideo() {
            // console.log(311,this.radio)
            this.isProduct = 1;
            this.getElectricityVideo();
        },
        adminCurrentChange(val) {
            this.adminPages.currentPageNum = val;
            this.getElectricityVideo();
        },
        //获取电商视频列表
        getElectricityVideo(type) {
            if (type !== "next") {
                // this.adminPages.currentPageNum = 1;
                this.productList = [];
                this.isNext = true;
            }
            let param = {};
            if (this.radio === "日榜") {
                if (this.isListDate === "") {
                    param = {
                        date: "2024-04-14",
                        date_type: "day",
                        page: this.adminPages.currentPageNum,
                        limit: this.adminPages.eachPageNum, //页面显示条数
                        keyword: this.searchContent,
                    };
                } else {
                    param = {
                        date_type: "day",
                        date: this.isListDate,
                        page: this.adminPages.currentPageNum,
                        limit: this.adminPages.eachPageNum, //页面显示条数
                        keyword: this.searchContent,
                    };
                }
            } else if (this.radio === "周榜") {
                if (this.isListDate === "") {
                    param = {
                        date_type: "week",
                        page: this.adminPages.currentPageNum,
                        limit: this.adminPages.eachPageNum, //页面显示条数
                        keyword: this.searchContent,
                    };
                } else {
                    param = {
                        date_type: "week",
                        date: this.isListDate,
                        page: this.adminPages.currentPageNum,
                        limit: this.adminPages.eachPageNum, //页面显示条数
                        keyword: this.searchContent,
                    };
                }
            } else if (this.radio === "月榜") {
                if (this.isListDate === "") {
                    param = {
                        date_type: "month",
                        page: this.adminPages.currentPageNum,
                        limit: this.adminPages.eachPageNum, //页面显示条数
                        keyword: this.searchContent,
                    };
                } else {
                    param = {
                        date_type: "month",
                        date: this.isListDate,
                        page: this.adminPages.currentPageNum,
                        limit: this.adminPages.eachPageNum, //页面显示条数
                        keyword: this.searchContent,
                    };
                }
            }

            this.$shttp.axiosGetBy(this.$api.jd_goods_video_list, param, (res) => {
                console.log(341, res);
                if (res.code === 200) {
                    if (res.data.data) {
                        if (res.data.data.length < 10) {
                            this.isNext = false;
                            console.log("长度不够");
                        }

                        if (this.data_type === 27) {
                            const data = res.data.data.pop();
                            res.data.data.unshift(data);
                        } else if (this.data_type === 25) {
                            const data = res.data.data.shift();
                            res.data.data.push(data);
                        }

                        this.productList = [...this.productList, ...res.data.data];
                        this.adminPages.total = res.data.total;
                    }
                }
            });
        },
        // 选择日期
        selectDayDate(val) {
            let timeDay = val;
            console.log("日榜", val);
            this.isListDate = timeDay;
            this.adminPages.currentPageNum = 1;
            this.productList = [];
            let param = {
                date_type: "day",
                date: timeDay,
                page: this.adminPages.currentPageNum,
                limit: this.adminPages.eachPageNum, //页面显示条数
            };
            this.$httpStudent.axiosGetBy(this.$api.getTakeGoodsVideoList, param, (res) => {
                if (res.code === 200) {
                    if (res.data.data) {
                        this.productList = res.data.data;
                    }
                }
            });
        },
        // 选择周
        selectWeekDate(val) {
            let firstDay = new Date(val.getFullYear(), 0, 1); //2020-01-01
            let dayOfWeek = firstDay.getDay(); //2020-01-01是周三  dayOfWeek==3
            let spendDay = 1;
            if (dayOfWeek != 0) {
                spendDay = 7 - dayOfWeek + 1; // 5 离下周一还有5天
            }
            firstDay = new Date(val.getFullYear(), 0, 1 + spendDay); // 2020-01-06是2020年第一个周一，是2020年第二个周
            let d = Math.ceil((val.valueOf() - firstDay.valueOf()) / 86400000); // 当前时间距离2020-01-06有几天
            let result = Math.ceil(d / 7); // 换算成周为单位 2020-01-06result是0,但其实是第二个周，所以默认加2
            let year = val.getFullYear();
            let week = result + 2; //如果使用的是默认为加2（如果将自然周设置为周一到周日则是加1）
            let startTime = this.dateFormatTwo(val.valueOf() - 86400000); // 开始时间
            let endTime = this.dateFormatTwo(val.valueOf() + 5 * 86400000); //    结束时间
            let finish = endTime.substring(0, 10);
            this.lweekVal = finish;
            console.log("周榜", this.lweekVal);
            this.isListDate = finish;
            this.adminPages.currentPageNum = 1;
            this.productList = [];
            let param = {
                date_type: "week",
                date: this.lweekVal,
                page: this.adminPages.currentPageNum,
                limit: this.adminPages.eachPageNum, //页面显示条数
            };
            this.$httpStudent.axiosGetBy(this.$api.getTakeGoodsVideoList, param, (res) => {
                if (res.code === 200) {
                    if (res.data.data) {
                        this.productList = res.data.data;
                    }
                }
            });
        },
        // 选择月
        selectMonthDate(val) {
            let date = new Date();
            let dateTimeFormatTime = this.dateFormatTwo(date);
            let nowTime = dateTimeFormatTime.substring(0, 7); //当前年月
            let nowMothTime = dateTimeFormatTime.substring(0, 10);
            this.adminPages.currentPageNum = 1;
            this.productList = [];
            if (val == nowTime) {
                console.log("月榜", nowMothTime);
                this.isListDate = nowMothTime;
                let param = {
                    date_type: "month",
                    date: nowMothTime,
                    page: this.adminPages.currentPageNum,
                    limit: this.adminPages.eachPageNum, //页面显示条数
                };
                this.$httpStudent.axiosGetBy(this.$api.getTakeGoodsVideoList, param, (res) => {
                    console.log(420, res);
                    if (res.code === 200) {
                        if (res.data.data) {
                            if (res.data.data) {
                                this.productList = res.data.data;
                            }
                        }
                    }
                });
            } else {
                let str = "-20";
                let timeVal = val.concat(str);
                console.log(428, timeVal);
                this.isListDate = timeVal;
                let param = {
                    date_type: "month",
                    date: timeVal,
                    page: this.adminPages.currentPageNum,
                    limit: this.adminPages.eachPageNum, //页面显示条数
                };
                this.$httpStudent.axiosGetBy(this.$api.getTakeGoodsVideoList, param, (res) => {
                    console.log(436, res);
                    if (res.code === 200) {
                        if (res.data.data) {
                            if (res.data.data) {
                                this.productList = res.data.data;
                            }
                        }
                    }
                });
            }
        },
        toVideoDetail(row) {
            this.$router.push({
                path: "/training/dsVideoDetail",
                query: { options: JSON.stringify(row) },
            });
        },
        toVideoDetailTwo(row) {
            this.$router.push({
                path: "/training/dsVideoDetail",
                query: { options: JSON.stringify(row) },
            });
        },
        toAnalysis(row, goodsAnalyzes) {
            this.$router.push({
                path: "/training/dsVideoDetail",
                query: { options: JSON.stringify(row), name: goodsAnalyzes },
            });
        },
    },
};
</script>

<style scoped lang="scss">
.dropdownItem {
    &:hover {
        background: #ffffff;
        color: #1e33e3;
    }
}
.dsVideoRank {
    height: calc(100vh - 70px);
    padding-block: 20px;
    box-sizing: border-box;

    // margin: auto;
    // margin-top: 20px;
    // width: 101%;
    /*padding: 20px 20px 0 0;*/
    /*overflow: scroll;*/

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .dsVideoRank-header {
        width: calc(100% - 280px);
        margin: auto;
        background: #ffffff;
        overflow: hidden;
        .dsVideoRank-underline {
            display: flex;
            margin-left: 14px;
            margin-right: 14px;
            /*margin-top: 14px;*/
            border-bottom: 1px solid rgba(234, 234, 234, 1);
        }
        .listChoices {
            margin-left: 12px;
            margin-top: 23px;
            margin-bottom: 24px;
        }
        .dateSelect {
            margin-left: 22px;
            margin-top: 23px;
        }
        .searchContent {
            margin-top: 23px;
            margin-left: 23px;
            ::v-deep .searchInput {
                width: 389px;
                background: #fff3f3f6;
                color: rgba(153, 153, 153, 1);
            }
            ::v-deep .searchInput::-webkit-input-placeholder {
                color: rgba(153, 153, 153, 1);
            }
        }
        .commodityClassify {
            width: 100%;
            display: inline-block;
            margin-top: 22px;
            overflow: hidden;
            background: #ffffff;
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            .commodityClassify-underline {
                margin-left: 27px;
                margin-right: 12px;
                border-bottom: 1px solid rgba(234, 234, 234, 1);
                margin-bottom: 0;
                .commodityClassify-box {
                    ::v-deep.el-dropdown {
                        line-height: 30px;
                        border: 1px solid #ffffff;
                        &:hover .el-icon-arrow-down {
                            transition: 0.5s;
                            transform: rotate(180deg);
                            color: #1e33e3 !important;
                        }
                    }
                    ::v-deep.elDropdown {
                        border: 1px solid #1e33e3;
                        border-radius: 4px;
                        color: #1e33e3;
                        .el-icon-arrow-down {
                            transition: 0.5s;
                            transform: rotate(180deg);
                            color: #1e33e3 !important;
                        }
                    }
                }
                .span-spfl {
                    color: rgba(51, 51, 51, 1);
                }
                .span-all {
                    width: 55px;
                    text-align: center;
                    border-radius: 4px;
                    line-height: 30px;
                    &:hover {
                        border: 1px solid rgba(35, 56, 230, 1);
                        color: rgba(35, 56, 230, 1);
                    }
                }
                .span-alls {
                    width: 55px;
                    text-align: center;
                    border-radius: 4px;
                    line-height: 30px;
                    border: 1px solid rgba(35, 56, 230, 1);
                    color: rgba(35, 56, 230, 1);
                }
                span {
                    display: inline-block;
                    /*margin-bottom: 56px;*/
                }
                .fill {
                    height: 56px;
                }
            }
        }
        ::v-deep.el-table td {
            border-bottom: 8px solid #f3f3f6;
        }
        .tableList {
            .videoImg {
                width: 100px;
                height: 130px;
            }
            .ranking-num {
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
            }
            .describe-title {
                color: #333333;
                font-size: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                line-height: 1;
            }
            .describe-content {
                width: 89%;
                color: #333333;
                font-size: 14px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                line-height: 1;
                span {
                    color: #ffcc66;
                }
            }
            .likeAdd-like {
                display: inline-block;
                color: #333333;
                font-size: 14px;
            }
            .likeAdd-add {
                display: inline-block;
                width: 60px;
                height: 28px;
                background: rgba(255, 240, 241, 1);
                font-size: 12px;
                color: #ff606e;
                text-align: center;
                line-height: 28px;
                margin-left: 8px;
            }
            .author-name {
                line-height: 1;
                margin-top: 0;
                text-align: left;
                font-size: 14px;
                color: #333333;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: center;
            }
            .author-fans {
                line-height: 1;
                margin-top: -10px;
                text-align: left;
                font-size: 12px;
                color: #999999;
                text-align: center;
            }
            .data-icon {
                display: inline-block;
                width: 28px;
                height: 28px;
                background: #4b5ef1;
                color: #ffffff;
                border-radius: 50%;
                text-align: center;
                line-height: 28px;
            }
            .play-icon {
                display: inline-block;
                width: 28px;
                height: 28px;
                background: #ff0707;
                color: #ffffff;
                border-radius: 50%;
                text-align: center;
                line-height: 28px;
                margin-left: 6px;
            }
            .chart-icon {
                display: inline-block;
                width: 28px;
                height: 28px;
                background: #ffb624;
                color: #ffffff;
                border-radius: 50%;
                text-align: center;
                line-height: 28px;
                margin-left: 6px;
            }
        }
    }
}
</style>
